// extracted by mini-css-extract-plugin
export default {"card":"X3Vhqjs_pSxCNYC8Ha3b"};